import { supabase } from './supabaseClient';

export const supabaseAuth = { currentUser: null };

export const normalizeSupabaseUser = (user) => {
    if (!user) return null;
    const providers = user.app_metadata?.providers || [];
    return {
        ...user,
        uid: user.id,
        phoneNumber: user.phone || null,
        providerData: providers.map((providerId) => ({
            providerId: providerId === 'email' ? 'password' : providerId,
            email: user.email || null,
            phoneNumber: user.phone || null,
            displayName: user.user_metadata?.full_name || null,
            photoURL: user.user_metadata?.avatar_url || null,
        })),
    };
};

export const onSupabaseAuthStateChanged = (callback) => {
    if (!supabase) {
        supabaseAuth.currentUser = null;
        callback(null);
        return () => {};
    }

    let eventHandled = false;
    const settle = (user) => {
        if (eventHandled) return;
        eventHandled = true;
        supabaseAuth.currentUser = normalizeSupabaseUser(user || null);
        callback(supabaseAuth.currentUser);
    };

    const fallback = setTimeout(() => settle(null), 3000);
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
        clearTimeout(fallback);
        settle(session?.user || null);
    });

    supabase.auth.getSession().then(({ data, error }) => {
        clearTimeout(fallback);
        if (error) {
            settle(null);
        } else {
            settle(data.session?.user || null);
        }
    }).catch((error) => {
        console.error('Unable to restore Supabase session:', error);
        clearTimeout(fallback);
        settle(null);
    });

    return () => {
        clearTimeout(fallback);
        subscription.unsubscribe();
    };
};

export const signOutSupabase = async () => {
    if (!supabase) throw new Error('Supabase is not configured.');
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
};
